import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Loader, Text, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import { getNumberAsLocaleNumber } from 'utils/numbers';
import SelectionCountPill from './SelectionCountPill';

const SelectionTotalsSummary = memo(
    ({ accountsCount = 0, contactsCount = 0, isLoading = false }) => {
        const theme = useTheme();
        const safeAccountsCount = Math.max(Number(accountsCount) || 0, 0);
        const safeContactsCount = Math.max(Number(contactsCount) || 0, 0);
        const totalCount = safeAccountsCount + safeContactsCount;

        if (isLoading) {
            return (
                <div className="fm-select-recipients-modal__footer-summary">
                    <Loader type="xsmall" borderSize={1} />
                </div>
            );
        }

        return (
            <div className="fm-select-recipients-modal__footer-summary">
                <Text
                    type="body"
                    className="fm-select-recipients-modal__footer-total"
                    color={theme.colors.textLight.secondary}
                    medium
                >
                    {getLiteral('label_total')}: {totalCount}
                </Text>
                <SelectionCountPill
                    icon="accounts"
                    countLabel={`${safeAccountsCount} ${getLiteral('label_accounts')}`}
                />
                <SelectionCountPill
                    icon="contacts"
                    countLabel={`${safeContactsCount} ${getLiteral('label_contacts')}`}
                />
            </div>
        );
    },
);

SelectionTotalsSummary.displayName = 'SelectionTotalsSummary';

SelectionTotalsSummary.propTypes = {
    accountsCount: PropTypes.number,
    contactsCount: PropTypes.number,
    isLoading: PropTypes.bool,
};

export default SelectionTotalsSummary;
